/* eslint complexity: 0, max-statements: 0 */
import _ from '../../../util/underscore-wrapper';
import InputRegistry from './InputRegistry';

function createInput(Input, options) {
  if (InputRegistry.isBaseInput(Input)) {
    return Input.prototype ? new Input(_.omit(options, 'input')) : Input;
  } else {
    return Input;
  }
}

function create(options) {
  options = _.clone(options);
  if (options.input) {
    return createInput(options.input, options);
  }
  const Input = InputRegistry.get(options);

  if (!Input) {
    throw new Error('unknown input: ' + options.type);
  }
  return createInput(Input, options);
}

function supports(options) {
  return !!options.input || !!InputRegistry.get(options);
}

export default {
  create: create,
  supports: supports
};



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/views/forms/helpers/InputFactory.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/views/forms/helpers/InputFactory.js